module.exports = __webpack_public_path__ + "media/images/front/about/aboutdba_point03-1-3bbff2caa8dd0e4e45e66e32b5c4f54a.jpg";